import {
  SCA_SET_VIEW,
  SCA_SET_FILTERS,
  SCA_SET_DATA,
  SCA_SET_ROW,
  SCA_SET_SIDEBAR,
  SCA_SET_LOADING,
  SCA_SET_MODAL_DETAILS,
  SCA_SET_GRID,
  SCA_SET_GRID_DATA,
  SCA_SET_TOTAL_ROWS,
  SCA_SET_LAST_PAGE,
  SCA_SET_GRID_LOADING,
  SCA_SET_FILTERS_DATA,
  SCA_SET_FILTERS_LOADING,
  SCA_SET_GRID_RELOAD_DATA,
  SCA_SET_DATA_GRID_ONLY_ROWS_OF_INTEREST,
  SCA_SET_ROW_VIDEO,
} from './enums/DashboardTypes';

export const initialState = {
  filters: {
    loading: true,
    data: {
      stores: [],
      terminals: [],
      transactionTypes: [],
      transactionSubTypes: [],
      clerks: [],
      status: [],
      threshold: { min: 0, max: 0 },
      totalItemsThreshold: { min: 0, max: 10 },
    },
    selected: [],
  },
  data: {
    sites_online: 7,
    sites_deployed: 2,
    totals: {
      current: {
        total: 0,
        total_of_interest: 0,
      },
      previous: {
        total: 0,
        total_of_interest: 0,
      },
    },
    stores: {
      current: [],
      previous: [],
    },
    clerks: {
      current: [],
      previous: [],
    },
    line_chart: [],
  },
  grid: {
    data: [],
    lastPage: 0,
    totalRows: 0,
    loading: false,
    reloadData: 0,
    showOnlyRowsOfInterest: true,
  },
  row: [],
  sidebar: false,
  modalDetails: false,
  loading: false,
};

const DashboardSCAReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCA_SET_VIEW:
      return { ...state, filters: { ...state.filters, view: action.data } };
    case SCA_SET_DATA:
      return { ...state, data: action.data };
    case SCA_SET_GRID:
      return { ...state, grid: action.data };
    case SCA_SET_GRID_DATA:
      return { ...state, grid: { ...state.grid, data: action.data } };
    case SCA_SET_GRID_LOADING:
      return { ...state, grid: { ...state.grid, loading: action.value } };
    case SCA_SET_GRID_RELOAD_DATA:
      return {
        ...state,
        grid: { ...state.grid, reloadData: state.grid.reloadData + 1 },
      };
    case SCA_SET_DATA_GRID_ONLY_ROWS_OF_INTEREST:
      return {
        ...state,
        grid: { ...state.grid, showOnlyRowsOfInterest: action.value },
      };
    case SCA_SET_TOTAL_ROWS:
      return { ...state, grid: { ...state.grid, totalRows: action.data } };
    case SCA_SET_LAST_PAGE:
      return { ...state, grid: { ...state.grid, lastPage: action.data } };
    case SCA_SET_ROW:
      return { ...state, row: action.data };
    case SCA_SET_ROW_VIDEO:
      return {
        ...state,
        row: {
          ...state.row,
          loading_video: false,
          video_url: action.value,
        },
      };
    case SCA_SET_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, selected: action.data },
      };
    case SCA_SET_FILTERS_DATA:
      return { ...state, filters: { ...state.filters, data: action.data } };
    case SCA_SET_FILTERS_LOADING:
      return { ...state, filters: { ...state.filters, loading: action.value } };
    case SCA_SET_SIDEBAR:
      return { ...state, sidebar: !state.sidebar };
    case SCA_SET_MODAL_DETAILS:
      return { ...state, modalDetails: !state.modalDetails };
    case SCA_SET_LOADING:
      return { ...state, loading: action.value };
    default:
      return state;
  }
};
export default DashboardSCAReducer;
